import React, { FC, useEffect, useState } from "react";
import { I18nextProvider } from "react-i18next";

import { useFlags, withLDProvider } from "launchdarkly-react-client-sdk";

import i18next from "./i18n/index";
import CategoryHistory from "./containers/MyAccount/CategoryHistory";
import News from "./containers/MyAccount/News";
import { getLDRelayURL } from "./utils";

const clientSideId = "62baf3989195871574e35e6c";
const { launchDarklyURL, LDUser } = getLDRelayURL();

interface AppProps {
  componentType?: string | null;
}

const App: FC<AppProps> = ({ componentType }) => {
  const ldFlags = useFlags();
  const [apiDomain, setLdApiDomain] = useState("");

  useEffect(() => {
    if (ldFlags.apiDomain) {
      setLdApiDomain(ldFlags.apiDomain);
    }
  }, [ldFlags]);

  if (apiDomain) {
    return (
      <div className="vbz-lf">
        <I18nextProvider i18n={i18next}>{componentType === "news" ? <News /> : <CategoryHistory />}</I18nextProvider>
      </div>
    );
  }
  return <div />;
};

export default withLDProvider({
  clientSideID: clientSideId,
  user: { key: LDUser },
  reactOptions: {
    useCamelCaseFlagKeys: false,
  },
  options: {
    baseUrl: launchDarklyURL,
  },
})(App) as FC<AppProps>;

App.defaultProps = {
  componentType: undefined,
};
